import * as React from 'react';

import { stores, storesContext } from 'contexts';

type StoresProviderProps = {};

export const StoresProvider: React.FC<React.PropsWithChildren<StoresProviderProps>> = ({ children }) => (
  <storesContext.Provider value={stores}>{children}</storesContext.Provider>
);
